import { defineComponent as _defineComponent } from 'vue'
import AddedToCartProduct from './AddedToCartProduct.vue';
import AppliedWarranty from './AppliedWarranty.vue';
import bugsnagClient from 'JS/global/bugsnag';
import MultipleProductSummary from './MultipleProductSummary.vue';
import QuickAddProducts from './QuickAddProducts.vue';
import UiButton from 'JS/components/UiButton.vue';
import WarrantySidebar from './WarrantySidebar.vue';
import { AddToCartProduct, AddToCartSuccessResponse } from 'JS/services/ProductService';
import { addWarranty } from 'JS/pdp/services/AddToCartService';
import { computed, ref } from 'vue';
import { ILocalStoreJson } from 'src/js/types/LocalStore';
import { IProductGroupSelectorValue, IWarranty } from 'JS/types/Product';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddToCartSuccess',
  props: {
    loading: { type: Boolean },
    addToCartInfo: null,
    pdpSelectedAttributes: null,
    carouselTrackingUrl: null,
    localStore: null
  },
  emits: ["loading", "maxhit", "close", "setfocus"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'loading', loading: boolean): void,
	(e: 'maxhit'): void,
	(e: 'close'): void,
	(e: 'setfocus'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	loading: boolean,
	addToCartInfo: AddToCartSuccessResponse,
	pdpSelectedAttributes: Record<string, IProductGroupSelectorValue>,
	carouselTrackingUrl?: string,
	localStore: ILocalStoreJson
}



const showErrorMessage = ref<boolean>(false);
const warrantiesUnresolved = ref<boolean>(true);
const appliedWarranty = ref<IWarranty>(null);
const hasMultipleProducts = computed<boolean>(() => props.addToCartInfo.addedProducts.length > 1);
const firstProduct = computed<AddToCartProduct>(() => props.addToCartInfo.addedProducts[0]);

const showWarrantySidebar = computed<boolean>(() =>
	!hasMultipleProducts.value
	&& firstProduct.value.warrantyOptions
	&& warrantiesUnresolved.value);

const headerText = computed<string>(() =>
	!hasMultipleProducts.value
		? "Added to Cart"
		: "Added " + props.addToCartInfo.addedProducts.length + " Items to Cart"
);



function continueShopping() {
	emit('close');
}

function maxItemsHit() {
	emit('maxhit');
}

function goToCart() {
	emit('close');
	toggleLoading(true);
	window.location.href = '/cart/';
}

function toggleLoading(loading: boolean) {
	emit('loading', loading);
}

async function selectWarrantyOption(product: AddToCartProduct, warrantySku: string): Promise<void> {
	await updateWarranty(product.blainNumber, product.quantity, warrantySku);
}

async function updateWarranty(productBlainNumber: string, warrantyQty: number, warrantySku: string): Promise<void> {
	toggleLoading(true);
	try {
		const response = await addWarranty(productBlainNumber, warrantyQty, warrantySku);
		if (response.success) {
			showErrorMessage.value = false;
			appliedWarranty.value = response.warranty;
			warrantySelectionComplete();
		} else {
			showErrorMessage.value = true;
		}
	} catch (e) {
		bugsnagClient.notify(e);
		showErrorMessage.value = true;
	} finally {
		toggleLoading(false);
	}
}

function warrantySelectionComplete() {
	warrantiesUnresolved.value = false;
	emit('setfocus');
}

return { __sfc: true,props, showErrorMessage, warrantiesUnresolved, appliedWarranty, hasMultipleProducts, firstProduct, showWarrantySidebar, headerText, emit, continueShopping, maxItemsHit, goToCart, toggleLoading, selectWarrantyOption, updateWarranty, warrantySelectionComplete, AddedToCartProduct, AppliedWarranty, MultipleProductSummary, QuickAddProducts, UiButton, WarrantySidebar }
}

})